var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "common-bread-container" }, [_c('div', { staticClass: "common-bread-title" }, [_c('a', { attrs: { "href": _vm.path } }, [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('svg-icon', { staticClass: "arrow-right", attrs: { "icon-class": "ic_arrow_right", "size": 12 } }), _vm._v(" "), _c('project-rename', { ref: "projectRename", attrs: { "projectName": _vm.templateConfig.name, "textMaxLength": 50 }, on: { "updateProjectName": _vm.handleRename } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };